"use client";

import React from "react";
import { Marquee } from "@/components/trademania-2/shared";

export default function Ticker({ items }: { items?: string[] }) {
  if (!items?.length) return null;

  return (
    <div className="mx-[6px] flex h-[7.125rem] items-center rounded-b-[4px] bg-[#D9F9B9]">
      <Marquee speed={1.1} trackClassName="items-center">
        {items.map((item, i) => (
          <span key={i} className="flex shrink-0 items-center gap-[3.25rem] pr-[3.25rem]">
            <span className="whitespace-nowrap font-geist text-[1.75rem] font-medium leading-[2.125rem] tracking-[.02em] text-[#0B0C0D]">
              {item}
            </span>
            <span className="h-[.875rem] w-[.875rem] shrink-0 rounded-full bg-[#0B0C0D]" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
